import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

function ProductModal({ product, fullscreen, show, setShow }) {
  const [count, setCount] = useState(0);

  const images = product?.images || [];

  const next = () => {
    if (count < images.length - 1) {
      setCount(count + 1);
    }
  };

  const previous = () => {
    if (count > 0) {
      setCount(count - 1);
    }
  };

  useEffect(() => {
    if (show) setCount(0);
  }, [show]);

  return (
    <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)} >
      <Modal.Header closeButton >
        <Modal.Title>{count + 1}/{images.length}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="gap-3 d-flex align-items-center justify-content-center">
          <Button variant="light" onClick={previous} disabled={count === 0}
            style={{
              position: "absolute",
              left: "35px",
              top: "50%",
              transform: "translate(-50%, -50%)"
            }}>
            <FaArrowLeft size={30} />
          </Button>
          <img
            src={`${process.env.REACT_APP_API_URL}${images[count]}`}
            alt={product?.name}
            className="img-fluid"
            style={{ maxHeight: '100vh', maxWidth: '100%' }}
          />
          <Button variant="light" onClick={next} disabled={count === images.length - 1}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translate(-50%, -50%)"
            }}
          >
            <FaArrowRight size={30} />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ProductModal;
